import restful, { fetchBackend } from 'restful.js';
import { apiBase } from './restConstants';
import csrfToken from './cookieUtils';

const api = restful(apiBase, fetchBackend(fetch));

api.identifier('id');

api.addRequestInterceptor((config) => {
  const { headers } = config;

  const token = csrfToken();
  if (token !== null) {
    headers['X-CSRF-TOKEN'] = token;
  }

  // just return modified arguments
  return {
    headers,
    credentials: 'same-origin',
  };
});

export default api;



// WEBPACK FOOTER //
// ./book/src/commons/rest/restApi.js